export { default } from "./vehicles.web";
